import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import { OpalApi, OpalApiResponseDocument } from '../../schema'

type ReadSmartCategory = OpalApi<'ReadSmartCategorySmartBlocksBFFV1', 200>
type ReadSmartCategoryResponse = OpalApiResponseDocument<
  'ReadSmartCategorySmartBlocksBFFV1',
  200
>

export const readSmartCategory: ReadSmartCategory = ({
  params,
}: Parameters<ReadSmartCategory>[0] = {}) => {
  if (!params) {
    throw new Error(
      'readSmartCategory must be provided with params.path.workspace_id and params.path.smart_category_id'
    )
  }

  const url = new URL(
    `/asgard-bff/${params.path.workspace_id}/smart_categories/${params.path.smart_category_id}/smart_blocks`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get<ReadSmartCategoryResponse>(url.toString())
    .then((res) => res.data)
}
